import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

/** Custom options the configure the tooltip's default show/hide delays. */
export const delayedTooltip: MatTooltipDefaultOptions = {
    showDelay: 700,
    hideDelay: 100,
    touchendHideDelay: 100,
};
